import throttle from 'lodash.throttle'

$(() => {
  let $copilotWrap = $('#copilot-wrap')
  let $button = $('#copilot-button')
  let $popup = $('#copilot-popup')
  let $iframe = $popup.find('iframe')
  let activeClass = 'active'
  let iframeLoadedClass = 'loaded'
  let hashTrigger = 'copilot'
  let defaultUrl = 'https://copilotstudio.microsoft.com/environments/Default-c44beb75-a067-4a3a-a0f0-eb0d45e98411/bots/cr212_faqTestZalWeb/webchat?__version__=2'

  function loadIframe(url) {
    if ($iframe.attr('src') !== url) {
      $iframe.attr('src', url)
    }
  }

  function getCopilotUrl() {
    let hash = location.hash.slice(1)

    if (hash === hashTrigger) {
      return defaultUrl
    } else if (hash.startsWith(hashTrigger + '/')) {
      return atob(hash.slice(hashTrigger.length + 1))
    }
  }

  function show() {
    $copilotWrap.addClass(activeClass)
  }

  function hide() {
    $copilotWrap.removeClass(activeClass)
  }

  function open() {
    loadIframe(getCopilotUrl())
    show()
  }

  function close() {
    hide()

    history.replaceState(null, null, window.location.pathname)
    checkHash()
  }

  function checkHash() {
    if (getCopilotUrl()) {
      open()
    } else {
      hide()
    }
  }

  $iframe.on('load', function () {
    $iframe.addClass(iframeLoadedClass)
  })

  checkHash()

  $(window).on('hashchange', function () {
    checkHash()
  })

  $button.on('click', function (e) {
    e.stopPropagation()
    e.preventDefault()

    if (getCopilotUrl()) {
      close()
    } else {
      history.replaceState(null, null, '#' + hashTrigger)
      checkHash()
    }
  })


  if (window.CSS && window.CSS.supports('(--margin: 1px)')) {
    // Use window.innerHeight instead of 100vh to avoid
    // problems with browser navbar on mobile devices
    function setPopupHeight() {
      $popup.css('--height', `calc(${window.innerHeight}px - var(--margin))`)
    }

    setPopupHeight()
    $(window).on('resize', throttle(setPopupHeight, 100))
  }

  // Rewrite all links to copilot to a hash
  $(`a[href^="${defaultUrl}"]`).each(function () {
    let url = $(this).attr('href')
    $(this).attr('href', `#${hashTrigger}/${btoa(url)}`)
    $(this).removeAttr('target')
  })
})
